import { useMemo } from 'react'
import { aiGeneratedNeedsReview } from '../utils'

export const useAiReviewNeeded = (test) => {
  const { isReviewRequired, itemGroups } = test || {}
  return useMemo(
    () => isReviewRequired || aiGeneratedNeedsReview(itemGroups || []),
    [isReviewRequired, itemGroups]
  )
}
